import type { Tag } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchTags(context: ApiContext, entityType?: string): Promise<{ tags: Tag[] }> {
  return apiContextFetch<{ tags: Tag[] }>(context, `tags${entityType ? `?entity_type=${entityType}` : ""}`)
}

export function createTag(context: ApiContext, tag: Partial<Tag>) {
  return apiContextFetch<Tag>(context, `tags`, {
    method: "POST",
    body: JSON.stringify({ tag }),
  })
}

export function updateTag(context: ApiContext, id: string, tag: Partial<Tag>) {
  return apiContextFetch<Tag>(context, `tags/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ tag }),
  })
}

export function destroyTag(context: ApiContext, tag: Tag) {
  return apiContextFetch<Tag>(context, `tags/${tag.id}`, {
    method: "DELETE",
  })
}
